"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicTransform = void 0;
const class_validator_1 = require("class-validator");
// import NetworkModel from '../base/NetworkModel'
const Range_1 = require("./Range");
class PublicTransform {
    constructor(data) {
        this.id = data.id;
        this.translateX = data.translateX;
        this.translateY = data.translateY;
        this.scaleX = data.scaleX;
        this.scaleY = data.scaleY;
        this.scaleIsZoom = data.scaleIsZoom;
        this.rotateZ = data.rotateZ;
        this.opacity = data.opacity;
        this.name = data.name;
    }
}
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicTransform.prototype, "id", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsObject(),
    __metadata("design:type", typeof (_a = typeof Range_1.IRange !== "undefined" && Range_1.IRange) === "function" ? _a : Object)
], PublicTransform.prototype, "translateX", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsObject(),
    __metadata("design:type", typeof (_b = typeof Range_1.IRange !== "undefined" && Range_1.IRange) === "function" ? _b : Object)
], PublicTransform.prototype, "translateY", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsObject(),
    __metadata("design:type", typeof (_c = typeof Range_1.IRange !== "undefined" && Range_1.IRange) === "function" ? _c : Object)
], PublicTransform.prototype, "scaleX", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsObject(),
    __metadata("design:type", typeof (_d = typeof Range_1.IRange !== "undefined" && Range_1.IRange) === "function" ? _d : Object)
], PublicTransform.prototype, "scaleY", void 0);
__decorate([
    class_validator_1.IsBoolean(),
    __metadata("design:type", Boolean)
], PublicTransform.prototype, "scaleIsZoom", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsObject(),
    __metadata("design:type", typeof (_e = typeof Range_1.IRange !== "undefined" && Range_1.IRange) === "function" ? _e : Object)
], PublicTransform.prototype, "rotateZ", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsObject(),
    __metadata("design:type", typeof (_f = typeof Range_1.IRange !== "undefined" && Range_1.IRange) === "function" ? _f : Object)
], PublicTransform.prototype, "opacity", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicTransform.prototype, "name", void 0);
exports.PublicTransform = PublicTransform;
// export class Transform extends NetworkModel implements ITransform {
// 	@IsString()
// 	id!: TransformId
// 	@IsNumber()
// 	order: number = DEFAULT_ORDER
// 	@IsBoolean()
// 	visible: boolean = true
// 	@IsString()
// 	name!: string
// 	@IsOptional()
// 	@IsObject()
// 	translateX?: IRange
// 	@IsOptional()
// 	@IsObject()
// 	translateY?: IRange
// 	@IsOptional()
// 	@IsObject()
// 	scaleX?: IRange
// 	@IsOptional()
// 	@IsObject()
// 	scaleY?: IRange
// 	@IsBoolean()
// 	scaleIsZoom: boolean = false
// 	@IsOptional()
// 	@IsObject()
// 	rotateZ?: IRange
// 	@IsOptional()
// 	@IsObject()
// 	opacity?: IRange
// }
